import env from "env.config";

import { DEFAULT_THEME_COLOR, DEFAULT_THEME_MODE, ThemeColor } from "@workspace/ui";

export const appConfig = {
  name: env.NEXT_PUBLIC_PRODUCT_NAME,
  url: env.NEXT_PUBLIC_URL,
  seoUrl: "https://marinesurveyreports.com",
  locale: env.NEXT_PUBLIC_DEFAULT_LOCALE,
  theme: {
    mode: env.NEXT_PUBLIC_THEME_MODE,
    color: env.NEXT_PUBLIC_THEME_COLOR,
  },
} as const;

export const themeStorageKeys = {
  color: "theme-config",
  mode: "theme",
} as const;

export const defaultThemeConfig = {
  color: DEFAULT_THEME_COLOR,
  mode: DEFAULT_THEME_MODE,
} as const;

export const themeColors = Object.values(ThemeColor);
